<template>
  <div
    :class="{
      'custom-control': true,
      'custom-switch': isSwitch,
    }"
  >
    <input
      class="custom-control-input"
      type="checkbox"
      :value="computedValue"
      :checked="computedChecked"
      :id="id"
      @change="updateModelValue"
      :switch="isSwitch"
    /><label class="custom-control-label" :for="id">
      <slot></slot>
    </label>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: [String, Boolean, Number],
      default: "yes",
    },
    uncheckedValue: {
      type: [String, Boolean, Number],
      default: null,
    },
    switch: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: [String, Boolean, Number],
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { internalValue: null };
  },
  methods: {
    updateModelValue() {
      if (this.modelValue === this.value) {
        this.internalValue = this.value;
      } else {
        this.internalValue = this.uncheckedValue;
      }
      this.$emit("input", this.internalValue);
    },
  },
  watch: {
    modelValue(val) {
      this.internalValue = val;
    },
    checked(val) {
      if (val) {
        this.internalValue = this.value;
      } else {
        this.internalValue = this.uncheckedValue;
      }
    },
  },
  computed: {
    id() {
      return (
        "_id" + String(Math.floor(Math.random() * Number.MAX_SAFE_INTEGER))
      );
    },
    computedValue() {
      return String(this.internalValue);
    },
    computedChecked() {
      return this.internalValue === this.value;
    },
    isSwitch() {
      return this.switch;
    },
  },
};
</script>